/**
 * Restores browser defaults for rich text injected into the app document.
 *
 * Tailwind Preflight resets block elements app-wide:
 *
 *     ol,ul,menu { list-style: none; margin: 0; padding: 0 }
 *     blockquote,dl,dd,h1..h6,hr,figure,p,pre { margin: 0 }
 *     h1..h6 { font-size: inherit; font-weight: inherit }
 *
 * That is right for app chrome, but wrong for a message body: sellers author these in the Quill editor,
 * which emits bare `<p>`, `<ul>`, `<ol>`, `<h1>`, `<h2>` and `<blockquote>` carrying no classes, so the
 * reset strips their bullets, indentation and paragraph spacing. The recipient's mail client applies its
 * own defaults and shows the message intact, which is why a seller comparing the two reports the sent
 * email as broken (X2-14337). Apply this to the element that receives such HTML.
 *
 * Only element-level formats need restoring. The editor registers *style* attributors for size, align and
 * indent (`RichEditor.tsx`, `IndentAttributor.ts`), so those arrive as inline styles that outrank Preflight
 * and already survive; bold and italic survive because Preflight keeps `b,strong` and `i,em`.
 *
 * Values are in `em` so they scale with the container, mirroring the UA stylesheet. The first and last
 * block drop their outer margin so this composes with a container that has its own padding.
 *
 * Prefer an iframe when the HTML is a whole document rather than a fragment — see `EmailDetails`, where the
 * email's own `<style>` would otherwise leak out and restyle the app.
 */
export const richTextClassName = [
    "[&_p]:my-[1em]",
    "[&_ul]:my-[1em] [&_ul]:list-disc [&_ul]:pl-10",
    "[&_ol]:my-[1em] [&_ol]:list-decimal [&_ol]:pl-10",
    "[&_blockquote]:my-[1em] [&_blockquote]:pl-10",
    "[&_h1]:my-[0.67em] [&_h1]:text-[2em] [&_h1]:font-bold",
    "[&_h2]:my-[0.83em] [&_h2]:text-[1.5em] [&_h2]:font-bold",
    "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
].join(" ");
